/**
 * Pure audio-source selector for side-by-side rooms. Tracks which panel
 * (racer slot) is the active audio source and whether it is muted. No DOM —
 * a later task applies `state()`/`isAudible(slot)` to the <video> elements.
 */
export function createAudioSourceSelector({ activeSlot = 1, muted = false } = {}) {
  let _active = activeSlot;
  let _muted = muted;
  return {
    state() { return { activeSlot: _active, muted: _muted }; },
    isAudible(slot) { return !_muted && slot === _active; },
    /** Tap a panel: switch to it (unmuted), or toggle mute if it is already active. */
    setActive(slot) {
      if (slot === _active) { _muted = !_muted; }
      else { _active = slot; _muted = false; }
      return this.state();
    },
    toggleMute() { _muted = !_muted; return this.state(); },
  };
}
